/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// Material ui Components
import { Button } from "@mui/material";

// Custom function
import pxToRem from "assets/theme/functions/pxToRem";

// Constants
import { Icons, ButtonTitles } from "utils/Constants";

export default function ResetFilterButton({ handleReset, marginTop = 5.5 }) {
  return (
    <Button
      sx={{
        mt: marginTop,
        mr: 1,
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", // ✅ Added shadow
        backgroundColor: "#fff",
        "&:hover": {
          backgroundColor: "#fff",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // Optional hover shadow
          border: "none",
        },
        fontSize: pxToRem(14),
        textTransform: "capitalize",
        border: "none",
      }}
      variant="outlined"
      color="info"
      onClick={handleReset}
      startIcon={Icons.RESET_FILTER}
    >
      {ButtonTitles.RESET_FILTER}
    </Button>
  );
}
